import React, { useMemo } from 'react';
import { Box } from '@common-fe/common-fe';

import { LockboxValidationError, lockboxValidationErrorTitle } from '@/modules/employer/components/Lockbox/lockbox.types';
import { MatchingListWrapper } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxMatchingList';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

import EmployeesSearch from './EmployeesSearch';
import SuggestedEmployees from './SuggestedEmployees';

const SelectEmployees = () => {
  const { originalLockbox, validationErrors } = useLockboxDetailsStore();
  const matchedEmployees = originalLockbox?.matchEmployees;

  const errorType = useMemo(() => {
    return validationErrors?.find((error) => error === LockboxValidationError.EMPLOYEE_REQUIRED
    || error === LockboxValidationError.HSA_ACCOUNT_REQUIRED
    || error === LockboxValidationError.HSA_ACCOUNT_CLOSED
    || error === LockboxValidationError.HSA_ACCOUNT_SHOULD_BE_OPEN
    || error === LockboxValidationError.AVAILABLE_BALANCE_MUST_BE_GREATER_THAN_ZERO) as LockboxValidationError | undefined;
  }, [validationErrors]);

  return (
    <MatchingListWrapper
      title="Employees"
      {...errorType ? { errorText: lockboxValidationErrorTitle?.[errorType]} : {}}
    >
      <SuggestedEmployees
        matchedEmployees={matchedEmployees}
      />
      <Box margin={{ top: 'spacing24' }}>
        <EmployeesSearch />
      </Box>
    </MatchingListWrapper>
  );
};

export default SelectEmployees;
